<template>
    <div class="produk">
       <div>
      <q-header v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" elevated class="bg-white text-black header-text shadow-2" style="padding: 10px 90px;">
        <div class="row no-wrap">
        <q-toolbar class="col-2">
          <q-toolbar-title> 
            <router-link to="/">
            <q-img src="img/marina.png" style="height: auto; max-width: 125px" />
            </router-link>
          </q-toolbar-title>
        </q-toolbar>
        <q-toolbar class="col-6">
          <q-input
            v-model="cari_value"
            debounce="500"
            outlined
            :dense="true"
            class="cari-data bg-white"
            color="purple-12"
            @keydown.enter="submit()"
            placeholder="Cari Produk..."
          >
            <template v-slot:append>
              <q-icon name="search" @click="submit()" style="font-size: 18px;" color="purple-12" />
            </template>
          </q-input>
        </q-toolbar>
        <q-toolbar class="col-4">
          <q-space />
          <q-tabs no-caps outside-arrows mobile-arrows inline-label active-color="purple-12">
            <q-route-tab to="/produk" label="Produk" icon="sym_o_shopping_bag" />
            <q-route-tab to="/wishlist" label="Wishlist" icon="sym_o_favorite" />
            <q-route-tab to="/keranjang" icon="sym_o_shopping_cart" label="Keranjang" />
            <q-route-tab v-if="cek_login == 1" to="/login" class="text-purple-12" icon="lock" >
                <q-tooltip
                  transition-show="flip-right"
                  transition-hide="flip-left"
                  class="bg-purple-12 text-white"
                >
                  Login
                </q-tooltip>
              </q-route-tab>
              <q-route-tab v-if="cek_login == 0" to="/akun" class="text-purple-12" icon="person" >
                <q-tooltip
                  transition-show="flip-right"
                  transition-hide="flip-left"
                  class="bg-purple-12 text-white"
                >
                  Akun
                </q-tooltip>
              </q-route-tab>
          </q-tabs>
        </q-toolbar>
      </div>
      </q-header>
      <q-header v-if="$q.screen.lt.sm" elevated class="bg-white text-black header-text shadow-1" style="padding: 10px 20px 10px 10px;">
        <div class="row no-wrap">
          <q-toolbar class="col-4">
            <q-toolbar-title>
              <router-link to="/">
                <q-img src="img/marina.png" style="height: auto; max-width: 200px" />
              </router-link>
            </q-toolbar-title> 
          </q-toolbar>
          <q-toolbar class="col-6">
            <q-input
              v-model="cari_value"
              debounce="500"
              outlined
              :dense="true"
              class="cari-data bg-white"
              color="purple-12"
              @keydown.enter="submit()"
              placeholder="Cari Produk..."
            >
              <template v-slot:append>
                <q-icon name="search" @click="submit()" style="font-size: 18px;" color="purple-12" />
              </template>
            </q-input>
          </q-toolbar>
          <q-toolbar class="col-2">
            <q-space />
            <q-btn dense flat round icon="menu" @click="rightDrawerOpen = !rightDrawerOpen"  />
          </q-toolbar>
        </div>
      </q-header>
      <q-drawer v-model="rightDrawerOpen" side="right" width="250" overlay behavior="mobile" elevated>
        <q-scroll-area class="fit"> 
              <q-list class="q-pa-sm">
                  <q-item clickable to="/produk" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_shopping_bag" />
                    </q-item-section>
                    <q-item-section>
                      Produk
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/wishlist" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_favorite" />
                    </q-item-section>
                    <q-item-section>
                      Wishlist
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/keranjang" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_shopping_cart" />
                    </q-item-section>
                    <q-item-section>
                      Keranjang
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item v-if="cek_login == 1" clickable to="/login" class="text-purple-12 text-weight-bold" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="lock" color="purple-12" />
                    </q-item-section>
                    <q-item-section>
                      Login
                    </q-item-section>
                  </q-item>
                  <q-item v-if="cek_login == 0" clickable to="/akun" class="text-purple-12 text-weight-bold" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="person" color="purple-12" />
                    </q-item-section>
                    <q-item-section>
                      Akun
                    </q-item-section>
                  </q-item>
                </q-list>
        </q-scroll-area>      
    </q-drawer>   
    </div>
      <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="row text-white" style="padding: 15px 110px;">
          <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
            Pencarian {{ artists[0].name }}
          </div>
          <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
            <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
              <q-breadcrumbs-el to="/" label="Beranda" />
              <q-breadcrumbs-el label="Pencarian" />
            </q-breadcrumbs>
          </div>
        </div>
      </div>
      <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
          <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 600;">
            Pencarian
          </div>
          <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
            <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
              <q-breadcrumbs-el to="/" label="Beranda" />
              <q-breadcrumbs-el label="Pencarian" />
            </q-breadcrumbs>
          </div>
        </div>
      </div>
      <div style="margin: 30px 100px 50px" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
            <div class="row items-start q-col-gutter-md" style="margin-bottom: 50px;">
              <div class="col-12 col-md-3" v-for="data in list_data">
                <q-card class="my-card">
                  <q-img :src="file_path+data.file" height="275px">
                    <template v-slot:loading>
                      <div class="text-purple-12">
                        <q-spinner-ios />
                      </div>
                    </template>
                  </q-img>
  
                  <q-card-section style="text-align: center;">
                        <q-btn
                          round
                          color="white"
                          icon="shopping_cart"
                          text-color="purple-12"
                          size="sm"
                          style="top: -15px; transform: translateY(-50%);"
                          @click="push_produk(data.id)"
                        />
                        <div class="produk-cat">
                          {{data.kategori_uraian}}
                        </div>
                        <div style="padding-bottom: 15px;">
                          <q-rating
                          v-model="model1"
                          max="5"
                          size="1em"
                          color="purple-12"
                          icon="star_border"
                          icon-selected="star"
                          icon-half="star_half"
                        />
                        </div>
                        <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                        <div class="produk-price1">Rp. {{data.harga}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                      </q-card-section>
                  
                </q-card>
              </div>
            </div>
            <div class="q-pa-lg flex flex-center">
                <q-btn @click="btn_prev" round outline size="sm" color="purple-12" icon="chevron_left" />
                <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
                <q-btn @click="btn_next" round outline size="sm" color="purple-12" icon="chevron_right" />
            </div>
      </div>
      <div v-if="$q.screen.lt.sm">
        <div style="margin: 20px">
            <div class="row items-start q-col-gutter-xs" style="margin-bottom: 15px;">
              <div class="col-3" v-for="data in list_data">
                <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                  <q-img :src="file_path+data.file" height="100px">
                    <template v-slot:loading>
                      <div class="text-purple-12">
                        <q-spinner-ios />
                      </div>
                    </template>
                  </q-img>
  
                  <q-card-section style="text-align: center;">
                        <q-btn
                          round
                          color="white"
                          icon="shopping_cart"
                          text-color="purple-12"
                          size="xs"
                          style="top: -15px; transform: translateY(-50%);"
                        />
                        <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                          {{data.kategori_uraian}}
                        </div>
                        <div style="margin-top: -5px;">
                          <q-rating
                          v-model="model1"
                          max="5"
                          size="0.5em"
                          color="purple-12"
                          icon="star_border"
                          icon-selected="star"
                          icon-half="star_half"
                        />
                        </div>
                        <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                          {{ data.brand }}
                        </div>
                        <div class="produk-price1-android">Rp. {{data.harga}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                      </q-card-section>
                  
                </q-card>
              </div>
            </div>
            <div class="q-pa-xs flex flex-center">
                <q-btn @click="btn_prev" round outline size="xs" color="purple-12" icon="chevron_left" />
                <span class="h_pagination-android">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
                <q-btn @click="btn_next" round outline size="xs" color="purple-12" icon="chevron_right" />
            </div>
        </div>
      </div>
      <q-footer v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" bordered class="bg-grey-1">
        <div class="row footer-area">
          <div class="col-12 col-md-4 footer-right">
            <q-img src="img/marina.png" style="width: 125px; margin-bottom: 15px;" />
            <div class="footer-text">
              Marina Market-Place merupakan media bagi perempuan pelaku usaha produk rumah tangga di Kabupaten Konawe Selatan
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="pin_drop" class="footer-icon" />
              </div>
              <div class="col-11">
                Dinas Pemberdayaan Perempuan & Perlindungan Anak Kabupaten Konawe Selatan
              </div>
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="mail" class="footer-icon" />
              </div>
              <div class="col-11">
                marina@konaweselatankab.go.id
              </div>
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="call" class="footer-icon" />
              </div>
              <div class="col-11">
                +91 123 4567890
              </div>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="footer-title">
              Market-Place
            </div>
            <div class="footer-text">
              Tentang Marina
            </div>
            <div class="footer-text">
              Kebijakan Privasi
            </div>
            <div class="footer-text">
              Syarat & Ketentuan
            </div>
            <div class="footer-text">
              Hubungi Kami
            </div>
            <div class="footer-text">
              Pusat Bantuan
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="footer-title">
              Kategori
            </div>
            <div class="footer-text">
              Cemilan
            </div>
            <div class="footer-text">
              Kerajinan Tangan
            </div>
            <div class="footer-text">
              Olahan Pangan
            </div>
            <div class="footer-text">
              Hasil Pertanian
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="footer-title">
              Marina Market-Place
            </div>
            <div>
              <q-input
                v-model="cari_value"
                debounce="500"
                outlined
                :dense="true"
                class="cari-data bg-white"
                color="purple-12"
                @keydown.enter="submit()"
                placeholder="Cari Produk..."
              >
                <template v-slot:append>
                  <q-icon name="search" @click="submit()" style="font-size: 18px;" color="purple-12" />
                </template>
              </q-input>
            </div>
            <div style="margin: 20px 0;">
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
            </div>
          </div>
        </div>
        <div class="footer-marina">
          &#169; 2024 | <span class="footer-span"> Marina</span>, All rights reserved.
        </div>
      </q-footer>
      <q-footer v-if="$q.screen.lt.sm" bordered class="bg-grey-1">
        <div class="row footer-area-android">
          <div class="col-4 footer-right-android">
            <q-img src="img/marina.png" style="width: 75px; margin-bottom: 7.5px;" />
            <div class="footer-text-android">
              Marina Market-Place merupakan media bagi perempuan pelaku usaha produk rumah tangga di Kabupaten Konawe Selatan
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="pin_drop" class="footer-icon" />
              </div>
              <div class="col-11">
                Dinas Pemberdayaan Perempuan & Perlindungan Anak Kabupaten Konawe Selatan
              </div>
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="mail" class="footer-icon" />
              </div>
              <div class="col-11">
                marina@konaweselatankab.go.id
              </div>
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="call" class="footer-icon" />
              </div>
              <div class="col-11">
                +91 123 4567890
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="footer-title-android">
              Market-Place
            </div>
            <div class="footer-text-android">
              Tentang Marina
            </div>
            <div class="footer-text-android">
              Kebijakan Privasi
            </div>
            <div class="footer-text-android">
              Syarat & Ketentuan
            </div>
            <div class="footer-text-android">
              Hubungi Kami
            </div>
            <div class="footer-text-android">
              Pusat Bantuan
            </div>
          </div>
          <div class="col-2">
            <div class="footer-title-android">
              Kategori
            </div>
            <div class="footer-text-android">
              Cemilan
            </div>
            <div class="footer-text-android">
              Kerajinan Tangan
            </div>
            <div class="footer-text-android">
              Olahan Pangan
            </div>
            <div class="footer-text-android">
              Hasil Pertanian
            </div>
          </div>
          <div class="col-4">
            <div class="footer-title-android">
              Marina Market-Place
            </div>
            <div style="margin: 0 0 10px;">
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
            </div>
          </div>
        </div>
        <div class="footer-marina" style="font-size: 7.5px;">
          &#169; 2024 | <span class="footer-span"> Marina</span>, All rights reserved.
        </div>
      </q-footer>
    </div>
  </template>
  
  <script>
  
//   import { ref } from 'vue'
  import Header from '@/components/Header.vue'
//   import { func } from 'joi';
  
  export default {
    name: 'SearchView',
    // components: {
    //   Header
    // },
    props: ['artists'],
    data () {
      return {
        rightDrawerOpen:false,
        list_data : [],
        model1: '3.5',
        cek_login: 0,
  
        file_path: this.$store.state.url.URL_APP + "uploads/",
  
        page_first: 1,
        page_last: 0,

        cari_value: this.artists[0].name,
      }
    },
    watch: {
      artists: {
          handler() {
              this.artists[0].name = "";
          },
          deep: true
      }
    },
    methods: {
      push_produk : function(id){
        // this.kirimWa();
        this.$router.push('/produk_detail/'+id);
      },
  
      // kirimWa: function () {
  
      //   console.log("DISINI TIDAK SAMPAI KAH");
      //   console.log(this.$store.state.url.WA);
      //   fetch(this.$store.state.url.WA, {
      //   method: "POST",
      //   // withCredentials: true,    
      //   // crossorigin: true,  
      //   // mode: 'no-cors', 
      //   headers: {
      //       "content-type": "application/json",
      //       'Access-Control-Allow-Origin':'*',
      //       'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS'
            
      //       // authorization: "kikensbatara " + localStorage.token
      //   },
      //   body: JSON.stringify({
      //       "no_hp" : "082291662895",
      //       "pesan" : "PESAN INI GAISSS",
      //       "token" : "wkrkwfbnebfkebfnefdng",
      //   })
      //   }).then(res => {
      //   console.log(res);
      //   console.log("BERHASIL KIRIM PESAN GAISS");
      //   });
  
      // },
  
      getView : function(){
        
        this.$store.commit('showLoading');
        console.log("WHAT");
        fetch(this.$store.state.url.URL_PRODUK  + "search", {
            method: "POST",
            headers: {
            "content-type": "application/json"
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
  
      kirimWa : function() {
        fetch(this.$store.state.url.URL_PRODUK  + "send_wa", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              nomor   : '082291662895',
              pesan   : 'PESAN WA INI GAISS'
            })
        })
        .then(res => res.json())
        .then(res_data => {
          console.log(res_data)
        });
      },

      // ====================================== PAGINATE ====================================
  
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          submit : function(){
            this.page_first = 1;
            this.getView();
          },
  
      // ====================================== PAGINATE ====================================
    },
    mounted() {
      this.getView();
      if (localStorage.token == undefined) {
        this.cek_login = 1;
      } else {
        this.cek_login = 0 
      }
      // console.log(this.cari);
    //   this.cari_value = JSON.parse(localStorage.cari);
    //   console.log(this.cari_value);
    }
  }
  </script>
  